import css from 'styled-jsx/css'

import { sizes } from '../../../theme'
import colors from '../../../theme/colors'


export default css`
  .container {
    height: calc(100vh - 8rem);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: relative;
    background-color:${colors.midnightExpress};   
  }

  .container :global(.inner) {
    width: 100%;
    max-width: ${sizes.body.desktop.maxWidth};
    z-index: 1;
  }

  .container :global(.pattern) {
    opacity: 0.3;
    background-color: transparent;   
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    // z-index: -2;
    user-select: none;
    pointer-events: none;
  }

  .container :global(.pattern div) {
    width: 100%;
    height: 100%;
  }

  .container :global(.highlighted-text) {
    line-height: 12rem;
  }
  /*
.container :global(.people) {
  background: url('/images/backgrounds/people.svg') no-repeat center;
  background-size: 70%;
  position: absolute;
  left: 50%;
  top: 0;
  width: 50%;
  height: 100%;
  max-width: 90rem;
}
*/
  .container :global(.baseline) {
    font-family: 'Taviraj-Light', serif;
    font-size: 11rem;
    color: ${colors.pureWhite};
    text-align:center;
    margin: 0.5rem;
    width:100%;
    padding-bottom:3rem;
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {

    .container :global(.baseline) {
      font-size: 4rem;
      position: relative;
      padding-bottom:0;
      padding-top:3rem;
    }

    .container :global(.inner) {
      display: flex;
      width: 100%;
      max-width: ${sizes.body.desktop.maxWidth};
      padding-left: 0;
      justify-content: center;
    }

    .container :global(.people) {
      display: block;
      position: relative;
      width: 100%;
      left: 0;
      top: 8rem;
      background-size: contain;
    }

    .container :global(.pattern) {
      height: 100%;
      width: 100%;
    }

    .container :global(.highlighted-text) {
      line-height: 7rem;
    }
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    .container {
      height: calc(100vh - 7rem);
    }

    .container :global(.baseline) {
      font-size: 6.4rem;
      padding-bottom:0;
      padding-top:2rem;
      
    }

    .container :global(.highlighted-text) {
      line-height: 4.5rem;
    }

    .container :global(.icon) {
      height: 3.2rem;
    }
  }
`
